//#region src/modules/shared/ActivityFeed/constants.ts
var ACTIVITY_FEED_SCOPE_LABELS = {
	bolo: "Bolo",
	event: "Event",
	"event-assignment-user-status": "Event User Status",
	"location-checkpoint-scan": "Checkpoint Scan",
	"location-checkpoint-tour": "Checkpoint Tour",
	"location-log-entry": "Location Log Entry",
	passdown: "Passdown",
	"patrol-route": "Patrol Route",
	"patrol-route-visit": "Patrol Visit",
	report: "Report",
	"report-status": "Report Status",
	shift: "Shift",
	"user-geo-fence": "User Geo Fence",
	"user-sos": "User SOS",
	"user-status": "User Status"
};
//#endregion
export { ACTIVITY_FEED_SCOPE_LABELS };

//# sourceMappingURL=constants.js.map